import type { FC } from 'react';
import { Card, Table, TableBody, TableCell, TableHead, TableRow, } from '@material-ui/core';
import Scrollbar from 'src/components/admin/Scrollbar';
import TableCellHeaderBasic from 'src/components/global/TableCellHeaderBasic';

const CurvaProduccionTableIngreso: FC<{ headers: any[], data: any }> = ({ headers, data }) => (
  <>
    <Card>
      <Scrollbar>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell style={{ minWidth: '200px' }} />
              {headers.map((item) => (
                <TableCellHeaderBasic
                  key={item.key}
                  align="left"
                  style={{ background: '#043263', border: 0, minWidth: '80px' }}
                >
                  {item.label}
                </TableCellHeaderBasic>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow hover>
              <TableCell style={{ background: '#043263', border: 0, color: 'white' }}>
                Fcst Diario (S/.)
              </TableCell>
              {data.fcstIngreso.map((item, index) => {
                const key = `weightF-row-${index}`;
                return (
                  <TableCell
                    key={key}
                    align="right"
                  >
                    {`${item.toFixed(2)}M`}
                  </TableCell>
                );
              })}
            </TableRow>
            <TableRow hover>
              <TableCell style={{ background: '#043263', border: 0, color: 'white' }}>
                Fcst Acumulado (S/.)
              </TableCell>
              {data.fcstIngresoA.map((item, index) => {
                const key = `weightFA-row-${index}`;
                return (
                  <TableCell
                    key={key}
                    align="right"
                  >
                    {`${item.toFixed(2)}M`}
                  </TableCell>
                );
              })}
            </TableRow>
            <TableRow hover>
              <TableCell style={{ background: '#043263', border: 0, color: 'white' }}>
                Real Diario (S/.)
              </TableCell>
              {data.realIngreso.map((item, index) => {
                const key = `weighR-row-${index}`;
                return (
                  <TableCell
                    key={key}
                    align="right"
                  >
                    {`${item.toFixed(2)}M`}
                  </TableCell>
                );
              })}
            </TableRow>
            <TableRow hover>
              <TableCell style={{ background: '#043263', border: 0, color: 'white' }}>
                Real Acumulado (S/.)
              </TableCell>
              {data.realIngresoA.map((item, index) => {
                const key = `weighRAI-row-${index}`;
                return (
                  <TableCell
                    key={key}
                    align="right"
                  >
                    {`${item.toFixed(2)}M`}
                  </TableCell>
                );
              })}
            </TableRow>
            <TableRow hover>
              <TableCell style={{ background: '#043263', border: 0, color: 'white' }}>
                Caída Diario
              </TableCell>
              {data.caidaIngreso.map((item, index) => {
                const key = `weighCI-row-${index}`;
                const background = item >= 0 ? '#ccff66' : '#f8c4aa';
                return (
                  <TableCell
                    key={key}
                    align="right"
                    style={{ background }}
                  >
                    {`${item.toFixed(2)}M`}
                  </TableCell>
                );
              })}
            </TableRow>
            <TableRow hover>
              <TableCell style={{ background: '#043263', border: 0, color: 'white' }}>
                Caída Acumulado
              </TableCell>
              {data.caidaIngresoA.map((item, index) => {
                const key = `weighCAI-row-${index}`;
                const background = item >= 0 ? '#ccff66' : '#f8c4aa';
                return (
                  <TableCell
                    key={key}
                    align="right"
                    style={{ background }}
                  >
                    {`${item.toFixed(2)}M`}
                  </TableCell>
                );
              })}
            </TableRow>
            <TableRow hover>
              <TableCell style={{ background: '#043263', border: 0, color: 'white' }}>
                Avance
              </TableCell>
              {data.avanceIngreso.map((item, index) => {
                const key = `weighAVI-row-${index}`;
                return (
                  <TableCell
                    key={key}
                    align="right"
                  >
                    {`${item.toFixed(2)}%`}
                  </TableCell>
                );
              })}
            </TableRow>
            <TableRow hover>
              <TableCell style={{ background: '#043263', border: 0, color: 'white' }}>
                Ratio Conversion
              </TableCell>
              {data.ratioConversion.map((item, index) => {
                const key = `weighRC-row-${index}`;
                return (
                  <TableCell
                    key={key}
                    align="right"
                  >
                    {`${item.toFixed(2)}%`}
                  </TableCell>
                );
              })}
            </TableRow>
          </TableBody>
        </Table>
      </Scrollbar>
    </Card>
  </>
);

export default CurvaProduccionTableIngreso;
